export function InfoIcon() {
  return <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.4" /><line x1="10" y1="9" x2="10" y2="14.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="10" cy="6.2" r="1" fill="currentColor" /></svg>;
}
